import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import * as XLSX from 'xlsx';

import { DatePipe } from '@angular/common';
import * as saveAs from 'file-saver';

@Component({
  selector: 'app-variable-pay-dashboard-popup',
  templateUrl: './variable-pay-dashboard-popup.component.html',
  styleUrls: ['./variable-pay-dashboard-popup.component.scss'],
})
export class VariablePayDashboardPopupComponent implements OnInit {

  operation: string | undefined;
  showDepartment: any = true;
  showaBandandGrade: any = true;
  showEmployee: any = true;
  showManager: any = true;
  showHOD: any = true;
  showDOJ: any = true;
  showMarketBenchmarkCTC: any = true;
  showMarketCorrection: any = true;
  showMarketCorrectionAmount: any = true;
  showEligibleEmployee:any = true;
  showDaysServedInVariablePayPeriod: any = true;
  departmentGroups: any[] = [];

  // Employees given CTC
  showEmpCTCDept: boolean = true;
  showEmpCTCBand: boolean = true;
  showEmpCTCEmployee: boolean = true;
  showEmpCTCManager: boolean = true;
  showEmpCTCHod: boolean = true;
  showEmpCTCDesignation: boolean = true;
  showEmpCTCDoj: boolean = true;
  showEmpCTCPA: boolean = true;
  showEmpCTCPM: boolean = true;
  showEmpVariableBonus: boolean = true;
  showEmpProratedVB: boolean = true;
  showEmpFinalVB: boolean = true;

  // Fixed Budget VP
  showFixedBudgetDept: boolean = true;
  showFixedBudgetBand: boolean = true;
  showFixedBudgetEmployee: boolean = true;
  showFixedBudgetManager: boolean = true;
  showFixedBudgetHod: boolean = true;
  showFixedBudgetDesignation: boolean = true;
  showFixedBudgetDoj: boolean = true;
  showFixedBudgetPA: boolean = true;
  showFixedBudgetPM: boolean = true;
  showFixedBudgetEmpVariableBonus: boolean = true;
  showFixedBudgetEmpProratedVB: boolean = true;
  showFixedBudgetEmpFinalVB: boolean = true;
  selectedYear:any;
  loggedInUserCompanyID:any;
  selectedFrequencyPeriod:any;
  loggedInUserRole:any;
  loggedInUserRoles:any;
  isShowMD:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private httpService: HttpService, 
  private encryptionService: EncryptionService,private datePipe: DatePipe,
  private config: Config) {
    this.operation = data.operation;
    this.selectedYear = data?.year;
    this.selectedFrequencyPeriod = data?.frequencyPeriod
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  }

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.variablePayDashboardPopups();
  }

  variablePayDashboardPopups() {
    switch (this.operation) {
      case 'fixedBudget':
        this.employeeFixedBudgetPopup();
        break;
      case 'empCTC':
        this.empCTCPopup();
        break;
      case 'eligibleEmployees':
        this.empEligiblePopup();
    }
  }

  toggleEligibleEmployee(column: string) {
    switch (column) {
      case 'showDepartment':
        this.showDepartment = !this.showDepartment;
        break;
      case 'showaBandandGrade':
        this.showaBandandGrade = !this.showaBandandGrade;
        break;
      case 'showEmployee':
        this.showEmployee = !this.showEmployee;
        break;
      case 'showManager':
        this.showManager = !this.showManager;
        break;
      case 'showHOD':
        this.showHOD = !this.showHOD;
        break;
      case 'showDOJ':
        this.showDOJ = !this.showDOJ;
        break;
      case 'showEligibleEmployee':
        this.showEligibleEmployee = !this.showEligibleEmployee;
        break;
      case 'showDaysServedInVariablePayPeriod':
        this.showDaysServedInVariablePayPeriod = !this.showDaysServedInVariablePayPeriod;
        break;
    }
  }

  toggleFixedBudget(column: string){
    switch(column){
      case 'showFixedBudgetDept':
      this.showFixedBudgetDept != this.showFixedBudgetDept
      break;
      case 'showFixedBudgetBand':
      this.showFixedBudgetBand != this.showFixedBudgetBand
      break;
      case 'showFixedBudgetEmployee':
      this.showFixedBudgetEmployee != this.showFixedBudgetEmployee
      break;
      case 'showFixedBudgetManager':
      this.showFixedBudgetManager != this.showFixedBudgetManager
      break;
      case 'showFixedBudgetHod':
      this.showFixedBudgetHod != this.showFixedBudgetHod
      break;
      case 'showFixedBudgetDesignation':
      this.showFixedBudgetDesignation != this.showFixedBudgetDesignation
      break;
      case 'showFixedBudgetDoj':
      this.showFixedBudgetDoj != this.showFixedBudgetDoj
      break;
      case 'showFixedBudgetPA':
      this.showFixedBudgetPA != this.showFixedBudgetPA
      break;
      case 'showFixedBudgetPM':
      this.showFixedBudgetPM != this.showFixedBudgetPM
      break;
      case 'showFixedBudgetEmpVariableBonus':
      this.showFixedBudgetEmpVariableBonus != this.showFixedBudgetEmpVariableBonus
      break;
      case 'showFixedBudgetProratedVB':
      this.showFixedBudgetEmpProratedVB != this.showFixedBudgetEmpProratedVB
      break;
      case 'showFixedBudgetEmpFinalVB':
      this.showFixedBudgetEmpFinalVB != this.showFixedBudgetEmpFinalVB
      break;
    }
  }

  toggleEmpCTC(column: string){
    switch(column){
      case 'showEmpCTCDept':
      this.showEmpCTCDept != this.showEmpCTCDept
      break;
      case 'showEmpCTCBand':
      this.showEmpCTCBand != this.showEmpCTCBand
      break;
      case 'showEmpCTCEmployee':
      this.showEmpCTCEmployee != this.showEmpCTCEmployee
      break;
      case 'showEmpCTCManager':
      this.showEmpCTCManager != this.showEmpCTCManager
      break;
      case 'showEmpCTCHod':
      this.showEmpCTCHod != this.showEmpCTCHod
      break;
      case 'showEmpCTCDesignation':
      this.showEmpCTCDesignation != this.showEmpCTCDesignation
      break;
      case 'showEmpCTCDoj':
      this.showEmpCTCDoj != this.showEmpCTCDoj
      break;
      case 'showEmpCTCPA':
      this.showEmpCTCPA != this.showEmpCTCPA
      break;
      case 'showEmpCTCPM':
      this.showEmpCTCPM != this.showEmpCTCPM
      break;
      case 'showEmpVariableBonus':
      this.showEmpVariableBonus != this.showEmpVariableBonus
      break;
      case 'showEmpProratedVB':
      this.showEmpProratedVB != this.showEmpProratedVB
      break;
      case 'showEmpFinalVB':
      this.showEmpFinalVB != this.showEmpFinalVB
      break;
    }
  }

  employeeFixedBudgetPopup() {
    var isHod = false
    if(this.loggedInUserRole == 'HOD' && !this.isShowMD){
      isHod = true
    }
    var year = this.selectedYear?.split('-');
    const request = {
       "band": [],
       "companyId": this.loggedInUserCompanyID,
       "department": [],
       "employeeName": [],
       "frequencyCycle": this.selectedFrequencyPeriod,
       "fromYear": year[0],
       "gender": null,
       "isEligible": true,
       "managerName": [],
       "rating": [],
       "searchString": null,
       "toYear": year[1],
       "vpCategory": [
         "Fixed Budget"
       ],
       "isHod": isHod
     }
     this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
       this.departmentGroups = result.data?.vpInputs;
     });
  }

  empCTCPopup() {
    var isHod = false
    if(this.loggedInUserRole == 'HOD' && !this.isShowMD){
      isHod = true
    }
  var year = this.selectedYear?.split('-');
   const request = {
      "band": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "employeeName": [],
      "frequencyCycle": this.selectedFrequencyPeriod,
      "fromYear": year[0],
      "gender": null,
      "isEligible": true,
      "managerName": [],
      "rating": [],
      "searchString": null,
      "toYear": year[1],
      "vpCategory": [
        "% Of CTC"
      ],
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
      this.departmentGroups = result.data?.vpInputs;
    });
  }

  empEligiblePopup() {
    var isHod = false
    if(this.loggedInUserRole == 'HOD' && !this.isShowMD){
      isHod = true
    }
    var year = this.selectedYear?.split('-');
    const request = {
       "band": [],
       "companyId": this.loggedInUserCompanyID,
       "department": [],
       "employeeName": [],
       "frequencyCycle": this.selectedFrequencyPeriod,
       "fromYear": year[0],
       "gender": this.selectedGender,
       "isEligible": true,
       "managerName": [],
       "rating": [],
       "searchString": null,
       "toYear": year[1],
       "vpCategory": [],
       "isHod": isHod
     }
     this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
       this.departmentGroups = result.data?.vpInputs;
      //  if(result.data.length!=0){
        this.totalEmp = result.data?.eligibleEmpCount?result.data?.eligibleEmpCount:0;
      //  }
     });
  }
  totalEmp:any;
  isToggleOn:boolean=false;
  selectedGender:any='Female'
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;
    if (event?.checked == true) {
      this.selectedGender = "Male";
      this.empEligiblePopup();
    } else if (event?.checked == false) {
      this.selectedGender = "Female";
      this.empEligiblePopup();
    }
  }
  getTotalRowSpan(bands: any[]): number {
    let totalRows = 0;
    bands.forEach(band => {
      if (band && Array.isArray(band.employees)) {
        totalRows += band.employees.length;
      }
    });
    return totalRows;
  }
  downloadExcelForInputeligibleEmployees() {
    const flattenedData: any[] = [];
    this.departmentGroups.forEach((department: any) => {
        department.bands.forEach((band: any) => {
            band.employees.forEach((employee: any) => {
                flattenedData.push({
                    Department: department.departmentName,
                    Band: band.bandName,
                    Employee: employee.employeeName,
                    Manager: employee.managerName,
                    HOD: employee.hodName,
                    DOJ: this.datePipe.transform(employee.employeeDOJ, "dd/MM/yyyy") ,
                    "Eligible Emp": employee.isEligible?'Yes':'No',
                    "Days Served in the VP period":employee.daysServed,
                });
            });
        });
    }); 
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Eligible Employees.xlsx';
    saveAs(data, fileName);
  }
  downloadExcelForInputfixedBudget() {
    const flattenedData: any[] = [];
    this.departmentGroups.forEach((department: any) => {
        department.bands.forEach((band: any) => {
            band.employees.forEach((employee: any) => {
                flattenedData.push({
                    "Department": department.departmentName,
                    "Band": band.bandName,
                    "Employee": employee.employeeName,
                    "Manager": employee.managerName,
                    "HOD": employee.hodName,
                    "Designation": employee.designation,
                    "DOJ": this.datePipe.transform(employee.employeeDOJ, "dd/MM/yyyy") ,
                    "Total Fixed CTC p.a": employee.totalFixedCTCpa,
                    "Total Fixed CTC p.f.": employee.totalFixedCTCpm,
                    "Variable bonus category %age of CTC OR fixed budget": employee.vpBonusCategoryOfCTC_OR_FixedBudget,
                    "Prorated VB %age / Amount": employee.proratedVPPercentAmount,
                    "Final VB Amount": employee.finalVPAmount,
                });
            });
        });
    }); 
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Employees Variable Pay .xlsx';
    saveAs(data, fileName);
  }
}
